import { ErrorMessage, Field } from "formik";
import * as React from "react";

interface FormikTextAreaInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  name: string;
}

const FormikTextAreaInput: React.FC<FormikTextAreaInputProps> = (props) => {
  return (
    <React.Fragment>
      <Field {...props}>
        {({ field }: { field: FormikTextAreaInputProps }) => {
          return (
            <div>
              <label>{props.label ? `${props.label}${props.required ? " *" : ""}` : ""}</label>
              <textarea
                className={"form-control form-control-lg"}
                placeholder=" "
                style={{
                  fontSize: 16,
                  outline: "none",
                  border: "1px solid #B6B6B6",
                  width: "100%",
                  height: "40px",
                  borderRadius: "8px",
                  padding: "10px 15px",
                  ...props.style,
                }}
                {...field}
              />
            </div>
          );
        }}
      </Field>
      <ErrorMessage className="text-danger mt-1" component="span" name={props.name ?? ""} />
    </React.Fragment>
  );
};

export default FormikTextAreaInput;
